export function deepCopy<T>(source: T): T {
    return Array.isArray(source)
        ? source.map((item) => deepCopy(item))
        : source instanceof Date
        ? new Date(source.getTime())
        : source && typeof source === 'object'
        ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
              Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop) as PropertyDescriptor);
              o[prop] = deepCopy(source[prop]);
              return o;
          }, Object.create(Object.getPrototypeOf(source)))
        : (source as T);
}

export function isNullOrUndefined<T>(object: T | undefined | null): object is T {
    return (object as T) !== undefined && (object as T) !== null;
}

export function assignFromPartial<T extends {}>(target: T, ...sources: Partial<T>[]) {
    return Object.assign(target, ...sources) as T;
}
